import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import { User, Lock } from 'lucide-react';

const LoginPage = () => {
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) navigate('/dashboard', { replace: true });
  }, [isAuthenticated, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!identifier.trim() || !password.trim()) {
      toast.error('Completa todos los campos');
      return;
    }
    setLoading(true);
    try {
      await login(identifier.trim(), password);
      toast.success('Bienvenido!');
      navigate('/dashboard');
    } catch (error) {
      const msg = error.response?.data?.detail || 'Usuario o contrasena incorrectos';
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center p-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-orange-500 to-orange-600 flex items-center justify-center mx-auto mb-4">
            <span className="text-white font-bold text-2xl">A</span>
          </div>
          <h1 className="text-2xl font-bold text-white">Iniciar Sesion</h1>
          <p className="text-zinc-500 text-sm mt-1">Ingresa tus credenciales</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5" data-testid="login-form">
          <div className="space-y-2">
            <Label htmlFor="identifier" className="text-zinc-300">Usuario o Email</Label>
            <div className="relative">
              <User className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-500" size={18} />
              <Input
                id="identifier"
                type="text"
                placeholder="Tu usuario o email"
                value={identifier}
                onChange={(e) => setIdentifier(e.target.value)}
                className="pl-10 bg-[#141414] border-zinc-800 focus:border-orange-500/50 h-12 text-white"
                autoComplete="username"
                data-testid="email-input"
              />
            </div>
          </div>

          <div className="space-y-2">
            <Label htmlFor="password" className="text-zinc-300">Contrasena</Label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-500" size={18} />
              <Input
                id="password"
                type="password"
                placeholder="Tu contrasena"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="pl-10 bg-[#141414] border-zinc-800 focus:border-orange-500/50 h-12 text-white"
                autoComplete="current-password"
                data-testid="password-input"
              />
            </div>
          </div>

          <Button
            type="submit"
            className="w-full bg-orange-500 hover:bg-orange-600 text-white rounded-xl h-12 text-base font-medium"
            disabled={loading}
            data-testid="login-submit"
          >
            {loading ? 'Entrando...' : 'Entrar'}
          </Button>
        </form>

        <p className="text-center text-zinc-600 mt-6 text-xs">
          Pide tus credenciales al administrador
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
